/**
 * Speak out loud the text given options.
 * SpeechOptions:
 * {
 *      lang: string;
 *      pitch: number;
 *      rate: number;
 *      volume: number;
 *      onFinished?: () => void;
 *      onError?: (error: Error) => void;
 * }
 * @param text The text to be spoken.
 * @param options  A `SpeechOptions` object.
 */
export function speak(text, options = {}) {
  const synth = window.speechSynthesis
  const u = new SpeechSynthesisUtterance(text)
  u.lang = options.lang || "en-US"
  u.rate = options.rate || 1
  u.volume = options.volume || 1
  u.onend = options.onFinished || (() => {})
  u.onerror = options.onError || (() => {})
  synth.speak(u)
}

/**
 *  Determine whether the Text-to-speech utility is currently speaking.
 */
export function isSpeaking() {
  const synth = window.speechSynthesis
  return synth.speaking
}

/**
 * Returns list of all available voices.
 */
export async function getAvailableVoicesAsync() {
  const synth = window.speechSynthesis
  return synth.getVoices()
}

/**
 * Interrupts current speech and deletes all in queue.
 */
export function stop() {
  const synth = window.speechSynthesis
  synth.cancel()
}

/**
 * Pauses current speech. This method is not available on Android.
 */
export function pause() {
  const synth = window.speechSynthesis
  synth.pause()
}
